import { Component, OnInit, HostBinding, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FieldConfig } from "../../field.interface";
@Component({
  selector: "app-input",
  template: `
      <div class="row">
        <mat-form-field class="col-12 demo-full-width"  [formGroup]="group" [hidden]="hidden()">
            <input matInput [readonly]="field.disabled" [formControlName]="field.name" (blur)="blur(group)"  (input)="valueChangeCallbackModal(group)" [placeholder]="field.label" [type]="field.inputType" >
            <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
                <mat-error *ngIf="group.get(field.name)?.hasError(validation.name)">{{validation.message}}</mat-error>
            </ng-container>
        </mat-form-field>
      </div>
`,
  styleUrls: ["./input.component.scss"],
})
export class InputComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  @Input() blur: (args: any) => void;
  @Input() valueChangeCallbackModal: (args: any) => void;
  @HostBinding('class') class = '';
  constructor() {
  }
  ngOnInit() {
    this.class = this.field.claseGrillaBootstrap;
    this.blur = this.field.blur?this.field.blur:this.funcionAuxNothing;
    this.valueChangeCallbackModal = this.field.valueChangeCallbackModal?this.field.valueChangeCallbackModal:this.funcionAuxNothing;
  }

  funcionAuxNothing(){ 
    //no hace nada solo para que no pinche el blur
  };

  hidden() {
    return this.field.visible === false;
  }
}
